module.exports = __webpack_public_path__ + "static/img/currency.7b6fbf49.svg";